module.exports = __webpack_public_path__ + "media/images/facebook-360ef5370b3c592660659f3336738ec9.svg";